import React, { useContext, useImperativeHandle, useState, useMemo } from 'react';
import { MdmFeatureTable } from './MdmFeatureTable';
import { MdmCpartBomTable } from './MdmCpartBomTable';

const CustomRecordListMap = {
  MdmFeatureTable,
  MdmCpartBomTable,
};

class CustomRecordList extends React.Component<any> {
  render() {
    const listType = this.props?.filterProps?.filterTable;
    if (!CustomRecordListMap[listType]) {
      return null;
    }
    return React.createElement(CustomRecordListMap[listType], { ...this.props }, null);
  }
}

export default CustomRecordList;
